// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function fromString(activeStatusString) {
  switch (activeStatusString) {
    case "not_terminated" :
        return /* NotTerminated */1;
    case "pending_onboarding" :
        return /* PendingOnboarding */2;
    case "terminated" :
        return /* Terminated */0;
    default:
      return ErrorUtils$Catalyst.raiseError("TerminationStatus.re", "Invalid 'activeStatusString' ", activeStatusString);
  }
}

function toString(activeStatusString) {
  switch (activeStatusString) {
    case /* Terminated */0 :
        return "terminated";
    case /* NotTerminated */1 :
        return "not_terminated";
    case /* PendingOnboarding */2 :
        return "pending_onboarding";
    
  }
}

export {
  fromString ,
  toString ,
  
}
/* No side effect */
